import { memo, MutableRefObject, ReactElement, useRef } from "react"
import { useClickAway } from "react-use"

type ChildrenProps = {
  ref: MutableRefObject<any>
}

type Props = {
  children(props: ChildrenProps): ReactElement
  onOutsideClick(event: MouseEvent): void
}

/** @deprecated Use `useClickAway` from `react-use` instead! */
export const OutsideClickHandler = memo<Props>(({ children, onOutsideClick }) => {
  const childrenRef = useRef<HTMLElement | null>(null)

  useClickAway(childrenRef, onOutsideClick)

  return children({ ref: childrenRef })
})
